import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { Link } from "react-router-dom";
import { fadeUp, fadeUpSlow, stagger, viewportOnce } from "../lib/motion";

const AboutClosing = () => (
    <section
        data-testid="about-closing"
        className="relative overflow-hidden bg-surface/40 py-28 lg:py-40"
    >
        <div className="relative mx-auto max-w-[1600px] px-6 md:px-10 lg:px-16">
            <motion.div
                variants={stagger}
                initial="hidden"
                whileInView="show"
                viewport={viewportOnce}
            >
                <motion.p
                    variants={fadeUp}
                    className="flex items-center gap-3 font-mono text-[13px] tracking-[0.3em] text-mist"
                >
                    <span className="h-1.5 w-1.5 bg-accent" />
                    EXPLORE
                </motion.p>
                <motion.h2
                    variants={fadeUpSlow}
                    data-testid="about-closing-headline"
                    className="mt-10 max-w-4xl text-4xl font-light leading-[1.1] text-white md:text-6xl"
                >
                    Your home-building journey deserves greater clarity
                    <span className="text-accent">.</span>
                </motion.h2>
                <motion.div variants={fadeUp} className="mt-8 max-w-2xl">
                    <p className="text-[16px] leading-relaxed text-mist">
                        Explore a more informed approach to residential
                        construction with BuildEase.
                    </p>
                    <p className="mt-4 font-display text-xl font-medium leading-snug text-white md:text-2xl">
                        Understand your project. Explore your possibilities.
                        Make decisions with greater clarity
                        <span className="text-accent">.</span>
                    </p>
                </motion.div>
                <motion.div
                    variants={fadeUp}
                    className="mt-12 flex flex-wrap items-center gap-4"
                >
                    <Link
                        to="/product"
                        data-testid="about-explore-buildease"
                        className="group inline-flex items-center gap-3 bg-accent px-8 py-4 text-[16px] font-semibold tracking-wide text-white transition-colors duration-300 hover:bg-[#ff7026]"
                    >
                        Explore BuildEase
                        <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                    </Link>
                    <Link
                        to="/join-the-pilot"
                        data-testid="about-get-started"
                        className="inline-flex items-center gap-3 border border-white/25 px-8 py-4 text-[16px] font-medium tracking-wide text-white transition-colors duration-300 hover:border-accent"
                    >
                        Get Started
                        <ArrowUpRight className="h-4 w-4" />
                    </Link>
                </motion.div>
            </motion.div>

            <motion.div
                variants={fadeUp}
                initial="hidden"
                whileInView="show"
                viewport={viewportOnce}
                data-testid="about-brand-signoff"
                className="mt-24 border-t border-white/10 pt-14"
            >
                <p className="font-display text-[clamp(2.4rem,7vw,6.5rem)] font-bold leading-none tracking-tight text-white">
                    BUILDEASE
                </p>
                <p className="mt-4 font-mono text-[13px] tracking-[0.45em] text-mist md:text-[15px]">
                    SIMPLIFY. BUILD. LIVE.
                </p>
            </motion.div>
        </div>
    </section>
);

export default AboutClosing;
